import { Controller } from "@hotwired/stimulus"
import { sendSlideImpressionBatch } from "../utils/slide_impression_batch"

// Records a featured card impression once per page view, and only while the
// card is actually displayed. Slots 4 and 5 stay hidden at 1024px and below.
export default class extends Controller {
  static targets = ["card"]
  static values = { endpoint: String }

  connect() {
    this.recordedIds = new Set()
    this.resizeObserver = new ResizeObserver(() => this.recordDisplayedCards())
    this.resizeObserver.observe(this.element)
    this.recordDisplayedCards()
  }

  disconnect() {
    this.resizeObserver?.disconnect()
  }

  recordDisplayedCards() {
    if (!this.hasEndpointValue) return

    const fresh = this.cardTargets.filter((card) => this.displayed(card) && !this.recordedIds.has(card.dataset.thingId))
    if (!fresh.length) return

    fresh.forEach((card) => this.recordedIds.add(card.dataset.thingId))
    this.fire(fresh)
  }

  displayed(card) {
    return card.getClientRects().length > 0
  }

  fire(cards) {
    sendSlideImpressionBatch(this.endpointValue, cards)
  }
}
